import { Component, Injector } from '@angular/core';
import { CMEAreaService, AuthorizationService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-cme-area',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class CMEAreaComponent extends BaseGridComponent {
  public descMaxLength: number = null;
  private readonly veUserService = new FilterableService();
  private readonly gaUserService: AuthorizationService;

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: CMEAreaService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.gaUserService = injector.get(AuthorizationService);
    this.descMaxLength = 50;
    this.appCardTitle = 'CME Areas';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean',
      },
      {
        field: 'MEName',
        title: 'Manufacturing Engineer',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'ME',
        refreshSecondaryData: this.populateProgramDetailsUserList
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['',  Validators.required],
      IsActive: [],
      MEName: [],
      ME: ['',  Validators.required],
    });
  }

  populateProgramDetailsUserList(dataItem: any) {
    dataItem.gaUserService.read('/moduleusers?moduleName=VE_GA')
      .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Name.localeCompare(b.Name));
      }
      dataItem.veUserService.next(result);
    });
  }
}
